export class Vehicle {
    BestMSRPPrice: number;
    Billboards: Array<any>;
    Categories: string;
    Subheading: string;
    Description: string;
    ExternalURL: string;
    File: string;
    ID: number;
    Images: Array<string>;
    MaxSaving: number;
    MyBestPrice: number;
    Name: string;
    PostName: string;
    PreName: string;
    ProgramVisibility: string;
    PromotionalText: string;
    Year: string;
}
